import styled from "styled-components";
import { CommonRechargeCard } from "../../atom";

export const PictureNormalRechargeWrapper = styled.div``;

export const PictureNormalRechargeCard = styled(CommonRechargeCard)`
  justify-content: center;
`;
